<!-- 家长监护-服务申请 -->
<template>
  <div class="service">
    <img class="banner" src="https://cdn.welove520.com/static/res/vue/playbay/banner.png">
    
    <p class="title">监护申请流程：</p>
    <img class="process" src="https://cdn.welove520.com/static/res/vue/playbay/process.png">

    <p class="title">流程介绍详细说明：</p>
    <p class="content">监护人提出申请</p>
    <p class="content">在监护人发现被监护人有沉溺平台游戏的情况下，监护人可向平台申请发起未成年人家长监护机制。</p>
    <p class="content">监护人需亲自通过邮寄方式向我司提供有效材料，向公司提出未成年人账户监控的申请。在收到邮件后，我司即开始启动监护机制审核流程，首先进入疑似账号身份确认期。</p>
    <p class="content">疑似账号身份确认期（15 个自然日）</p>
    <p class="content">在判断申请材料完整的情况下，我司将通过官方邮箱联系疑似帐号归属者，告知其在 15 个自然日内将按照监护人需求对其账号进行相关操作，并要求疑似账号归属者提供身份材料以便我司判定其与监护人监护关系；</p>
    <p class="content">若疑似账号归属者在 15 个自然日内不能提供有效身份证明或逾期提供，则默认为疑似账号归属者与被监护人身份相符。我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；</p>
    <p class="content">若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人相符，我司即按照监护人申请要求，对其游戏账号纳入防沉迷系统；</p>
    <p class="content">若疑似账号归属者在 15 个自然日内提供的身份证明与被监护人不符，我司则无法判定其与被监护人的身份关系。在此情况下，为保障用户游戏账号安全，我司将通知监护人通过公安机关出具账号找回协查证明，由我司协助被监护人找回游戏账号后再进行后续操作；</p>

    <p class="title">监护服务申请书：</p>
    <p class="content">流程介绍详细说明</p>
    <p class="content">表单1未成年人用户家长监控服务申请书</p>
    <p class="content">温馨提醒，您在邮寄申请书时，要记得一起提供如下资料：</p>
    <p class="content">附件1：申请人的身份证或户口本（复印件）</p>
    <p class="content">附件2：被申请人的身份证或户口本（复印件）</p>
    <p class="content">附件3：申请人与被申请人的监护法律关系证明（原件）</p>

    <Download/>
  </div>
</template>

<script>
import Download from "./Download";
export default {
  name: "Service",
  data() {
    return {};
  },
  components: {
    Download: Download
  },
  created() {
    this.$store.dispatch("initTabName", "parents");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.banner {
  margin-top: 30px;
  width: 100%;
}

.process {
  width: 1000px;
}

.title {
  font-size: 20px;
  color: #303032;
  text-align: center;
  margin: 50px 0 30px 0;
}

.content {
  font-size: 16px;
  color: #303032;
  text-align: justify;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/Service.vue